/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysharecredits2Inputs */

const en_summarysharecredits2 = /** @type {(inputs: Summarysharecredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits from sharing`)
};

const de_summarysharecredits2 = /** @type {(inputs: Summarysharecredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits durch Teilen`)
};

/**
* | output |
* | --- |
* | "Credits from sharing" |
*
* @param {Summarysharecredits2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysharecredits2 = /** @type {((inputs?: Summarysharecredits2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysharecredits2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysharecredits2(inputs)
	return de_summarysharecredits2(inputs)
});
export { summarysharecredits2 as "summaryShareCredits" }